import React, { useContext, useEffect, useRef, useState } from "react";
import Button from "../common/Button";

import { ReactComponent as ArrowRightSvg } from "../../assets/icons/arrow-right.svg";
import { ReactComponent as ArrowLeftSvg } from "../../assets/icons/arrow-left.svg";

import { ReactComponent as PanoramaSvg } from "../../assets/newProject/360-image.svg";
import { ReactComponent as ImageSvg } from "../../assets/newProject/image.svg";
import { ReactComponent as Model3DSvg } from "../../assets/newProject/3d.svg";
import { ReactComponent as DrawingSvg } from "../../assets/newProject/drawing.svg";
import { ReactComponent as FabricSvg } from "../../assets/newProject/fabric.svg";
import { ReactComponent as ArrowLeftCircleSvg } from "../../assets/newProject/arrow-left-circle.svg";
import { ReactComponent as ArrowRightCircleSvg } from "../../assets/newProject/arrow-right-circle.svg";

import imageTypeCover from "../../assets/temp/new-project-panorama.png";

import NewProjectContext from "../../contexts/NewProjectContext";
import AppContext from "../../AppContext";
import { langComponent } from "../../constants";
import { useLocation } from "react-router-dom";
import _ from "lodash";
import useWorks from "../../hooks/useWorks.js";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

const SelectType = () => {
  const { details, setDetails, goForward, goBackward } =
    useContext(NewProjectContext);
  const { user, getLang, designStyles } = useContext(AppContext);
  const { getWork } = useWorks();
  const Translation = getLang(langComponent.project);
  const TranslationCommon = getLang(langComponent.common);
  let location = useLocation();
  const [type, setType] = useState(
    details?.type || location?.state?.type || "panorama"
  );
  const [workType, setWorkType] = useState("");
  const [content, setContent] = useState({ title: "", desc: "" });
  const [init, setInit] = useState();

  const mapProgramName = {
    1: "sketchUp",
    2: "3dsMax",
    3: "revit",
    4: "cinema4D",
    5: "unreal",
    6: "rhino",
    7: "autocad",
    8: "archicad",
  };
  const mapRenderers = {
    1: "vray",
    2: "corona",
    3: "lumion",
    4: "enscape",
    5: "d5render",
  };

  const capitalizeFirst = (s) => (s && s[0].toUpperCase() + s.slice(1)) || "";
  useEffect(() => {
    if (location.state) {
      const state = location.state;

      if (state?.type && state.workType) {
        setType(state?.type);
        if (state?.type !== "panorama") {
          setWorkType(state?.workType);
        }
        setDetails({ type: state?.type, workType: state?.workType });
        goForward();
      }
    }
  }, [details]);

  useEffect(() => {
    const state = location.state;
    if (state?.id) {
      _init(state?.id);
    }
  }, []);

  useEffect(() => {
    handleTypeClick("panorama", "");
  }, []);

  const makeFile = async (name, path) => {
    let response = await fetch(path, {
      cache: "no-cache",
    });
    let data = await response.blob();
    let file = new File([data], name);
    return file;
  };

  const _init = async (id) => {
    const {
      _id,
      name,
      desc,
      price,
      title,
      banner,
      images,
      program,
      brief,
      files,
      discount,
      downloads,
      workFileTypes,
      designType,
      renderer,
    } = await getWork(id);
    let galleryList = _.sortBy(images, ["no"]);
    const lastImageNo = images[-1]?.no || 0;
    const mainImagePath = _.pullAt(galleryList, 0);

    const mainImageFile = await makeFile("mainImage", mainImagePath[0]?.path);
    setDetails((curr) => ({
      ...curr,
      _id,
      name,
      desc,
      price,
      title,
      discount,
      program: mapProgramName[program],
      mainOriginalFile: mainImageFile,
      mainImageId: mainImagePath[0]?._id,
      galleryList,
      brief,
      files,
      editMode: true,
      lastImageNo,
      downloads: downloads || 0,
      workFileTypes,
      designType,
      isEditMainImage: false,
      renderer: mapRenderers[renderer],
    }));
  };

  const handleTypeClick = (name, value) => {
    setType(name);

    let desc = "";

    if (name === "panorama") {
      desc = "Display stunning tours using panoramas";
    }

    if (name === "images") {
      desc = "Showcase your stunning images";
    }

    if (name === "3D Models") {
      desc = "Sell or showcase your 3d models";
    }

    if (name === "Materials and lighting") {
      desc = "Sell or showcase your material and lightings";
    }

    if (name === "Drawing and block CAD") {
      desc = "Sell or showcase your Drawings or block CADs";
    }

    if (name !== "panorama") {
      setWorkType(value);
    }

    setContent({
      title: capitalizeFirst(name),
      desc,
    });
  };

  const handleContinueClick = () => {
    if (!type) return;

    // * If type changed then clear every other details
    // TODO: Only clear when in detail changed (3d model, material & drawing should not be considered type changing)
    if (details.type !== type) {
      setDetails({ type, workType });
      goForward();
      return;
    }

    goForward();
  };

  const getActiveClassName = (typeName) => {
    const _classNames = ["new-project-type-list-image"];

    if (type === typeName) {
      _classNames.push("new-project-type-list-image__active");
    }

    if (type !== typeName) {
      _classNames.push("new-project-type-list-image__inactive");
    }

    return _classNames.join(" ");
  };

  const _getImageSrc = (typeName, value, selected) => {
    if (typeName === "panorama") {
      return (
        <PanoramaSvg
          width={selected ? 108 : 74}
          onClick={() => handleTypeClick("panorama", "")}
        />
      );
    }

    if (typeName === "images") {
      return (
        <ImageSvg
          width={selected ? 108 : 70}
          onClick={() => handleTypeClick("images", "")}
        />
      );
    }

    if (typeName === "3D Models") {
      return (
        <Model3DSvg
          width={selected ? 108 : 74}
          onClick={() => handleTypeClick(typeName, value)}
        />
      );
    }

    if (typeName === "Materials and lighting") {
      return (
        <FabricSvg
          width={selected ? 96 : 60}
          onClick={() => handleTypeClick(typeName, value)}
        />
      );
    }

    if (typeName === "Drawing and block CAD") {
      return (
        <DrawingSvg
          width={selected ? 92 : 58}
          onClick={() => handleTypeClick(typeName, value)}
        />
      );
    }

    return imageTypeCover;
  };

  if (!designStyles) return <></>;

  return (
    <>
      <div className="new-project-type">
        <h1 className="new-project__heading1">
          {Translation("Select a Project Type")}
        </h1>
        <div></div>
        <div className="new-project-type-list">
          <ArrowLeftCircleSvg
            className="new-project-type-list-arrow--left"
            width={48}
          />
          <Swiper
            grabCursor={true}
            spaceBetween={20}
            modules={[Pagination, Navigation]}
            slidesPerView={2}
            pagination={{
              clickable: true,
            }}
            navigation={{
              enabled: true,
              prevEl: ".new-project-type-list-arrow--left",
              nextEl: ".new-project-type-list-arrow--right",
            }}
            observer={true}
            observeParents={true}
            onInit={() => setInit(true)}
            breakpoints={{
              560: {
                slidesPerView: 3,
              },
              1024: { slidesPerView: 4 },
              1280: {
                slidesPerView: 5,
              },
            }}
            onSlideChange={(swiperCore) => {
              const { activeIndex, passedParams, currentBreakpoint } =
                swiperCore;

              if (activeIndex === 0) {
                handleTypeClick("panorama", "");
                return;
              }

              if (activeIndex === 1) {
                handleTypeClick("images", "");
                return;
              }

              const _workExchangeType =
                designStyles.workExchanges[activeIndex - 2];

              handleTypeClick(_workExchangeType.name, _workExchangeType.value);
            }}
          >
            {[
              { name: "panorama", value: "panorama" },
              { name: "images", value: "images" },
              ...designStyles.workExchanges,
            ].map((data, index) => {
              return (
                <SwiperSlide key={index}>
                  <div className={getActiveClassName(data.name)}>
                    {_getImageSrc(data.name, data.value, type === data.name)}
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
          <ArrowRightCircleSvg
            className="new-project-type-list-arrow--right"
            width={48}
          />
        </div>
        <div className={"new-project-type-description"}>
          <div className={"new-project-type-description__title"}>
            {content.title}
          </div>
          <div className={"new-project-type-description__content"}>
            {content.desc}
          </div>
        </div>
        <div className="new-project-cta">
          <Button
            label={"Return to Profile"}
            variant={"secondary"}
            leadingIcon={<ArrowLeftSvg />}
            onClick={() => goBackward()}
          />
          <Button
            label={TranslationCommon("Continue")}
            type="submit"
            trailingIcon={<ArrowRightSvg />}
            onClick={handleContinueClick}
            disabled={!type}
          />
        </div>
      </div>
    </>
  );
};

SelectType.propTypes = {};

export default SelectType;
